export const products = [
  {
    id: "0",
    title: "Encre Primaire",
    description: "Encres offset primaires de haute qualité, idéales pour des impressions précises et des couleurs intenses.",
    longDescription: "Les encres primaires sont conçues pour garantir une couverture uniforme et des couleurs éclatantes. Elles adhèrent parfaitement aux différents types de papier et assurent une constance sur l'ensemble des impressions, même lors de tirages importants.",
    category: "Matière Première",
    image: "encrePrimaire.png",
    stock: "Disponible",
  },
  {
    id: "1",
    title: "Encre Pantone",
    description: "Encres Pantone sur mesure, parfaites pour une reproduction fidèle des teintes et un rendu professionnel.",
    longDescription: "Les encres Pantone permettent une reproduction exacte des couleurs demandées, idéal pour les chartes graphiques et les projets nécessitant une précision chromatique. Elles offrent également une excellente résistance à la lumière et aux frottements.",
    category: "Matière Première",
    image: "encrePantone.png",
    stock: "Disponible",
  },
  {
    id: "2",
    title: "Encre UV",
    description: "Encres UV spéciales offrant une excellente durabilité, un séchage instantané et des effets uniques.",
    longDescription: "Les encres UV sèchent rapidement sous exposition à la lumière ultraviolette, ce qui permet d'éviter les bavures et d'obtenir un rendu net. Elles sont parfaites pour les impressions spéciales, avec des effets brillants ou texturés, et offrent une résistance élevée au temps et aux manipulations.",
    category: "Matière Première",
    image: "encreUV.png",
    stock: "Disponible",
  },
  {
    id: "3",
    title: "Plaque d'impression",
    description: "Plaques offset résistantes et précises, assurant une qualité constante et une longue durée de vie en production.",
    longDescription: "Ces plaques d'impression garantissent une reproduction fidèle des images et des textes, avec une grande précision. Elles sont conçues pour résister à de longues séries d'impression tout en conservant des détails nets et des bords définis.",
    category: "Matière Première",
    image: "plaques.png",
    stock: "Disponible",
  },
  {
    id: "4",
    title: "Wash 60",
    description: "Détergent efficace pour presses offset, éliminant rapidement les résidus d'encre et garantissant un nettoyage parfait.",
    longDescription: "Wash 60 est formulé pour dissoudre efficacement l'encre sans endommager les plaques ni les rouleaux. Il réduit le temps de nettoyage, améliore l'entretien des presses et assure des impressions nettes pour chaque production.",
    category: "Produits Chimiques",
    image: "wash.png",
    stock: "Disponible",
  },
  {
    id: "5",
    title: "Eau de Mouillage",
    description: "Solution de mouillage spécialement formulée pour assurer une impression stable et de haute qualité.",
    longDescription: "L'eau de mouillage stabilise l'humidité sur la plaque et le papier, empêchant les bavures et assurant un transfert précis de l'encre. Elle optimise la qualité d'impression, surtout sur des tirages prolongés et des papiers sensibles.",
    category: "Produits Chimiques",
    image: "mouillage.png",
    stock: "Disponible",
  },
  {
    id: "6",
    title: "Alcool Isopropylique (IPA)",
    description: "Produit chimique utilisé pour le contrôle du mouillage et la réduction des bavures lors des impressions offset.",
    longDescription: "L'IPA régule la tension superficielle de l'eau de mouillage, facilitant la séparation nette entre encre et zones non imprimées. Cela permet d'obtenir des tirages sans bavures et des couleurs plus uniformes sur chaque feuille.",
    category: "Produits Chimiques",
    image: "ipa.png",
    stock: "Disponible",
  },
  {
    id: "7",
    title: "Vernis Acrylique",
    description: "Vernis acrylique disponible en finition brillante ou mate, pour protéger et valoriser certaines zones imprimées.",
    longDescription: "Le vernis acrylique protège les impressions contre l'usure et les rayures tout en améliorant l'esthétique. Il peut être appliqué en spot ou sur toute la surface pour donner un rendu brillant, mat ou soft-touch selon le projet.",
    category: "Produits Chimiques",
    image: "vernis.png",
    stock: "Disponible",
  },
  {
    id: "8",
    title: "Gomme pour plaque",
    description: "Solution de gum pour protéger les plaques d'impression et prolonger leur durée de vie en empêchant l'oxydation.",
    longDescription: "La gomme protège les plaques des agressions chimiques et empêche la formation d'oxydation sur les zones non imprimées. Elle permet de stocker les plaques en toute sécurité et de prolonger leur durabilité avant réutilisation.",
    category: "Produits Chimiques",
    image: "gum.png",
    stock: "Disponible",
  },
  {
    id: "9",
    title: "Plate Cleaner",
    description: "Nettoyant professionnel pour plaques offset, éliminant efficacement encres et dépôts pour une impression nette.",
    longDescription: "Plate Cleaner permet de retirer les encres sèches et les dépôts de poussière sur les plaques. Il garantit que chaque impression commence avec une surface propre, améliorant la précision et la qualité finale du tirage.",
    category: "Produits Chimiques",
    image: "plateCleaner.png",
    stock: "Disponible",
  },
  {
    id: "10",
    title: "Dorure à chaud",
    description: "Films et rubans de dorure à chaud pour sublimer vos impressions avec des effets métalliques élégants et luxueux.",
    longDescription: "La dorure à chaud ajoute une touche premium aux imprimés, en appliquant des films métalliques sur des zones spécifiques. Elle est idéale pour les couvertures, les invitations et les documents haut de gamme, offrant un effet visuel raffiné.",
    category: "Matériaux de Finition",
    image: "dorure.png",
    stock: "Disponible",
  },
  {
    id: "11",
    title: "Pelliculage tout format",
    description: "Films de pelliculage brillants, mats ou soft-touch, adaptés à tous types de formats pour protéger et valoriser vos imprimés.",
    longDescription: "Le pelliculage protège les impressions contre les rayures, l'humidité et l'usure tout en améliorant l'aspect visuel. Il peut être appliqué sur tous les formats et types de papier, et permet de créer des textures et finitions variées selon les besoins du projet.",
    category: "Matériaux de Finition",
    image: "pelliculage.png",
    stock: "Disponible",
  },
  {
    id: "12",
    title: "Fil de Lin Reliure",
    description: "Fil de lin résistant pour reliure, idéal pour une finition artisanale, solide et esthétique de vos ouvrages.",
    longDescription: "Ce fil de lin est robuste et flexible, permettant de relier vos documents de manière sécurisée tout en offrant un aspect artisanal et élégant. Il est idéal pour les livres, brochures et autres supports reliés manuellement.",
    category: "Matériaux de Finition",
    image: "fildelin.png",
    stock: "Disponible",
  },
  {
    id: "13",
    title: "Reliure spirale / Wire-o",
    description: "Spirales métalliques ou plastiques pour relier vos documents avec style et praticité.",
    longDescription: "La reliure spirale permet d'assembler les documents de façon durable et pratique, facilitant l'ouverture complète des pages. Les spirales Wire-o offrent également un rendu professionnel pour les manuels, catalogues ou rapports.",
    category: "Matériaux de Finition",
    image: "reliureSpirale.png",
    stock: "Disponible",
  },
  {
    id: "14",
    title: "Blanchet d'impression",
    description: "Blanchet de haute qualité pour garantir une impression nette et précise sur vos presses.",
    longDescription: "Le blanchet assure le transfert uniforme de l'encre sur le papier, contribuant à une impression nette et sans bavures. Il est essentiel pour maintenir la qualité d'impression et prolonger la durée de vie de la presse.",
    category: "Consommables",
    image: "blanchet.png",
    stock: "Disponible",
  },
  {
    id: "15",
    title: "Poudre Antimaculante",
    description: "Poudre anti-maculante qui prévient les bavures et assure un séchage uniforme des encres.",
    longDescription: "Cette poudre empêche l'accumulation d'encre sur le papier et réduit les traces lors des impressions rapides. Elle améliore la régularité des tirages et la qualité globale des impressions offset.",
    category: "Consommables",
    image: "maculante.png",
    stock: "Disponible",
  },
  {
    id: "16",
    title: "Fil de Fer",
    description: "Fil métallique solide pour reliure et assemblage de documents imprimés avec fiabilité.",
    longDescription: "Le fil de fer est utilisé pour fixer solidement les documents, garantissant un maintien durable et sûr. Il convient aux documents reliés mécaniquement ou aux assemblages spécifiques nécessitant une robustesse élevée.",
    category: "Consommables",
    image: "fildefer.png",
    stock: "Disponible",
  },
  {
    id: "17",
    title: "Réglette Massicot",
    description: "Réglette de précision pour un découpage net et efficace des feuilles et supports.",
    longDescription: "La réglette assure des mesures précises et un alignement parfait lors du découpage. Elle est indispensable pour obtenir des bords droits et précis sur tous types de documents imprimés.",
    category: "Consommables",
    image: "reglette.png",
    stock: "Disponible",
  },
  {
    id: "18",
    title: "Bobine Emballage Étirable",
    description: "Film étirable robuste pour protéger et sécuriser vos impressions et produits finis.",
    longDescription: "Le film étirable enveloppe vos produits pour les protéger contre la poussière, l'humidité et les chocs légers pendant le transport et le stockage. Il est transparent et solide, garantissant la sécurité de vos impressions.",
    category: "Consommables",
    image: "etirable.png",
    stock: "Disponible",
  },
  {
    id: "19",
    title: "Aiguille de Reliure",
    description: "Aiguille professionnelle pour relier vos documents rapidement et avec précision.",
    longDescription: "Cette aiguille facilite l'insertion du fil ou de la spirale lors de la reliure, assurant un assemblage rapide et net. Elle est idéale pour les finitions artisanales ou professionnelles sur des documents variés.",
    category: "Consommables",
    image: "aiguille.png",
    stock: "Disponible",
  },
];
